import axiosInstance from "./axios";

export const fetchUserDetails = async (reviewProgram) =>
  axiosInstance
    .get("/accounts/legacy-account-details", {
      params: {
        reviewProgram: reviewProgram,
      },
    })
    .then((response) => response.data);

export const updateUserProfile = async (requestData) =>
  axiosInstance
    .put("/accounts/legacy-accounts-handler", requestData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);
